import React from 'react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offre" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-134" data-mp="17xuswfmwwmsb">
      <div className="mx-auto max-w-md" data-id="element-135" data-mp="1mo2182j7gpfa">
        <div className="text-center" data-id="element-136" data-mp="1mmqz075erpqa">
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-teal" data-id="element-137" data-mp="1hopgpoft3ufv">
            Paiement unique
          </span>
          <h2 className="mt-4 font-display text-[1.75rem] font-black leading-tight tracking-tight text-navy sm:text-[2.4rem]" data-id="element-138" data-mp="tzwexbci6sdc">
            Offre de Lancement{' '}
            <span className="italic text-grape" data-id="element-139" data-mp="13wre7wglowso">Imbattable</span>
          </h2>
        </div>

        <div className="relative mt-12 rounded-3xl border-2 border-tangerine bg-white px-7 pb-8 pt-11 shadow-soft" data-id="element-140" data-mp="yxy0q41bd5si">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-tangerine px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-141" data-mp="2fbogi81spihz">
            Pack Musique Prête™
          </span>

          <dl data-id="element-142" data-mp="pj5uqoeuwie0">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between gap-4 border-b border-navy/10 py-4 text-sm" data-id="element-143" data-mp="ujbm03h7s2vk">
                <dt className="text-navy/75" data-id="element-144" data-mp="zj6hkkbxpgmy">{row.label}</dt>
                <dd className="font-bold text-navy" data-id="element-145" data-mp="13iyqiy58posu">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between gap-4 border-b border-navy/10 py-4 text-sm" data-id="element-146" data-mp="6usgtwtgo67p">
              <dt className="font-bold uppercase tracking-wide text-navy" data-id="element-147" data-mp="btltxo4u5v7c">
                Valeur totale :
              </dt>
              <dd className="font-bold text-navy/40 line-through" data-id="element-148" data-mp="ft4bqb1d1q5y">382€</dd>
            </div>
          </dl>

          <p className="mt-6 text-center text-[11px] font-extrabold uppercase tracking-[0.18em] text-teal" data-id="element-149" data-mp="kn8nr8phgodw">
            Aujourd&apos;hui pour seulement
          </p>
          <p className="flex items-end justify-center gap-1 border-b border-navy/10 pb-7 pt-2" data-id="element-150" data-mp="3o8wgoymf47um">
            <span className="font-display text-6xl font-black leading-none text-tangerine" data-id="element-151" data-mp="vefsw15ns30k">
              19€
            </span>
          </p>

          <CtaButton label="Télécharger tout le pack maintenant" className="mt-7 w-full" data-id="element-152" data-mp="qete3na6mepn" />

          <p className="mt-4 text-center text-[11px] font-medium text-navy/50" data-id="element-153" data-mp="105xjpwdywn7t">
            Paiement unique · Accès illimité · Téléchargement instantané
          </p>
        </div>
      </div>
    </section>;
}